<template>
    <div>
        <Head :title="__(title)" />
        <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-col -mb-8 -mr-6 p-8">
                    <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Event name')" :is_required="true" required @blur="setEventLink" />
                    <div class="pb-8 pr-6 w-full lg:w-1/2">
                        <div class="form-label">Ubicación:</div>
                        <div class="location_selector w-full relative">
                            <div class="flex flex-col">
                                <div class="flex justify-between location___list__item px-1 py-2 mb-3" v-for="(location, li) in form.locations" :key="li">
                                    <div class="flex items-start items-center gap-3">
                                        <img :src="location.image" class="w-6 h-6 ml-4" />
                                        <div class="flex title text-sm">{{ location.name }}</div>
                                    </div>
                                    <div class="flex cursor-pointer items-center pr-2" @click="removeLocation(location)"><icon name="close" class="w-5 h-5"/></div>
                                </div>
                            </div>
                            <div class="flex items-center form-select w-full cursor-pointer select-none" @click="show_location_selector = !show_location_selector" :class="{'selected_ls':show_location_selector}">
                                Agregar ubicación
                            </div>
                            <div v-if="show_location_selector" class="flex flex-col location_selection overflow-auto">
                                <div class="flex justify-start items-center location_item gap-3 w-full" v-for="event_location in e_locations" :key="event_location.id">
                                    <img :src="event_location.image" class="w-6 h-6 ml-4" />
                                    <div class="flex flex-col w-full" @click="locationClickAction(event_location)">
                                        <div class="flex title text-sm">{{ event_location.name }}</div>
                                        <div class="flex text-xs">{{ event_location.short_description }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pr-6 pb-8 w-full">
                        <label class="form-label" >Description/Instructions:</label>
                        <ckeditor id="kbDetails" :editor="editor" v-model="form.details" :error="form.errors.details" :config="editorConfig" required></ckeditor>
                    </div>
                    <div class="pr-6 w-full">
                        <label class="form-label" >Event Color</label>
                    </div>
                    <div class="flex pr-6 pb-8 w-full color__selector">
                        <div class="flex flex-col color__item justify-start items-center relative pr-4 dark:border-gray-700" v-for="(color, ci) in event_colors" :key="ci">
                            <input v-model="form.color" type="radio" :value="color.color" name="bordered-radio" class="check w-8 h-8 text-blue-600 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                            <span :style="{'background-color': color.color}" ></span>
                            <label class="text-sm font-medium hidden absolute text-gray-900 dark:text-gray-300">{{ color.name }}</label>
                        </div>
                    </div>
                    <text-input v-model="form.link" :error="form.errors.link" class="pb-8 pr-6 w-full lg:w-1/2" :label="__('Event Link')" />

                    <div class="pr-6 pb-8 w-full">
                        <label class="form-label" >Date range</label>
                        <p class=" text-sm mb-4">Invitees can schedule...</p>
                        <div class="flex flex-col gap-4">
                            <div class="flex items-center">
                                <input class="who__call mr-3" type="radio" v-model="form.date_range.type" name="date_range" value="days" />
                                <text-input v-model="form.date_range.days" class="mr-3 w-20" />
                                <span>calendar days into the future</span>
                            </div>
                            <div class="flex gap-4 items-center">
                                <input class="who__call" type="radio" v-model="form.date_range.type" name="date_range" value="range" />
                                <div class="flex">Within a date range</div>
                                <Datepicker v-if="form.date_range.type === 'range'" input-class-name="cal_sel_range w-full" v-model="form.date_range.range" range :enable-time-picker="false" multi-calendars multi-calendars-solo :min-date="new Date()" />
                            </div>
                            <div class="flex gap-4">
                                <input class="who__call" type="radio" v-model="form.date_range.type" name="date_range" value="future" />
                                <span>Indefinitely into the future</span>
                            </div>
                        </div>
                    </div>

                    <div class="pb-8 w-full lg:w-1/3 duration__selection">
                        <label class="form-label" >Duration</label>
                        <div class="flex w-full items-center form-select cursor-pointer select-none" @click="show_duration_selector = !show_duration_selector" :class="{'selected_ls':show_duration_selector}">
                            <div v-if="duration_type !=='custom'">{{ this.form.duration.replace('_', ' ') }}</div>
                            <div v-else>custom</div>
                        </div>
                        <div v-if="show_duration_selector" class="select__dd flex flex-col">
                            <div class="select__dd__item" v-for="(minute, mi) in total_minutes" :key="mi" @click="selectedDuration(minute)">{{ minute.replace('_', ' ') }}</div>
                        </div>
                        <div class="flex pt-3 gap-3" v-if="duration_type === 'custom'">
                            <text-input class="w-[100px]" v-model="duration_time" placeholder="eg. 2" />
                            <div class="flex relative w-[65px]">
                                <div class="flex w-full items-center form-select cursor-pointer select-none" @click="show_duration_custom_selector = !show_duration_custom_selector" :class="{'selected_ls':show_duration_selector}">
                                    {{ duration_in }}
                                </div>
                                <div v-if="show_duration_custom_selector" class="select__dd flex flex-col top-1">
                                    <div class="select__dd__item" @click="selectedDurationIn('min')">min</div>
                                    <div class="select__dd__item" @click="selectedDurationIn('hrs')">hrs</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="pb-8 pr-6 w-full">
<!--                        <div class="flex justify-between">-->
<!--                            <div class="flex flex-col">-->
<!--                                <div class="form-label">How do you want to offer your availability for this event type?</div>-->
<!--                                <div class="flex">-->
<!--                                    <button class="btn btn-indigo">Use an existing schedule</button>-->
<!--                                    <button class="btn btn-indigo">Set custom hours</button>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <p class="opacity-50">Select one of your schedules or define custom hours specific to this type of event.</p>-->
<!--                        </div>-->
                        <div class="flex py-4">
                            <div class="form-label">Set your schedule hours</div>
                        </div>
                        <div class="flex flex-col border rounded">
                            <div class="flex gap-3 p-5">
                                <div class="flex flex-col w-full md:w-1/2 justify-between">
                                    <div class="flex">Time Zone</div>
                                    <div class="pt-3 pb-8 w-full min-w-[320px] relative">
                                        <div class="flex w-full items-center form-select cursor-pointer select-none" @click="show_z_sel = !show_z_sel" :class="{'selected_ls':show_z_sel}">
                                            {{ form.timezone }}
                                        </div>
                                        <input class="w-full p-2 border border-t-0 selected_ls border-b-gray-100 absolute" type="text" v-if="show_z_sel" placeholder="Search zone" v-model="typed_zone" @keyup="limitTimezone(typed_zone)" />
                                        <div v-if="show_z_sel" class=" select__dd top-[75px] zone__selector flex flex-col">
                                            <div class="flex justify-between zone__item select__dd__item" v-for="(timezone, ti) in filteredTimezone" :key="ti" @click="setTimezone(timezone)">
                                                <div class="zone__name">{{ timezone }}</div>
                                                <div class="zone__time">{{ moment.tz(timezone).format('h:mma') }}</div>
                                            </div>
                                            <div v-if="!filteredTimezone.length" class="select__dd__item">no timezone found!</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-col items-center w-full md:w-1/2">
<!--                                    <div class="flex">Save as a new schedule</div>-->
                                </div>
                            </div>
                            <div class="hours__area flex flex-col lg:flex-row justify-between">
                                <div class="flex flex-col w-full lg:w-3/5 gap-5 weekly__hours p-5">
                                    <div class="flex font-bold">Set your weekly hours</div>
                                    <div class="flex justify-between hour__day__item gap-3" v-for="(day, di) in days" :key="di">
                                        <div class="flex items-start">
                                            <div class="flex justify-start items-center gap-2 w-[65px] pt-3">
                                                <input class="flex justify-center items-center" type="checkbox" :checked="form.hours[day].length" @change="toggleHours(day)" />
                                                <div class="flex justify-center items-center form-label uppercase mb-0">{{ day }}</div>
                                            </div>
                                            <div class="flex flex-col gap-3 __hours">
                                                <div class="flex gap-3 items-center" v-for="(hour, hi) in form.hours[day]">
                                                    <div class="flex flex-col relative">
                                                        <input type="text" v-model="hour.start" class="form-input h__input w-[100px]" @click="showTimePicker($event,day, hi,'start')" />
                                                    </div>
                                                    -
                                                    <div class="flex flex-col relative">
                                                        <input type="text" v-model="hour.end" class="form-input h__input w-[100px]" @click="showTimePicker($event,day,hi,'end')" />
                                                    </div>
                                                    <div class="flex sh_icon delete" @click="deleteHours(day, hi)"><icon name="trash" class="w-4 h-4" /></div>
                                                </div>
                                                <div v-if="!form.hours[day].length" class="flex gap-3 justify-center items-center select-none h-[35px] opacity-75">
                                                    Unavailable
                                                </div>
                                            </div>
                                        </div>

                                        <div class="flex ml-2 gap-2 __clone__parent relative">
                                            <div class="flex sh_icon __add" @click="newInterval(day)"><icon name="plus" class="w-4 h-4" /></div>
                                            <div class="flex sh_icon __clone" @click="cloneSlot($event, day)"><icon name="clone" class="w-4 h-4" /></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-col gap-4 w-full lg:w-2/5 date__override p-5">
                                    <div class="flex">Add date overrides</div>
                                    <p class="flex opacity-50">Add dates when your availability changes from your weekly hours</p>

                                    <Datepicker calendar-class-name="e__type" v-model="selectedOverride" multi-dates :month-change-on-scroll="false" :enable-time-picker="false" ref="dateOverride" month-name-format="long" auto-apply keep-action-row :close-on-auto-apply="false" :min-date="new Date()" model-type="yyyy-MM-dd" @update:modelValue="handleOverrideDate">
                                        <template #trigger>
                                            <button class="override__btn clickable-text">Add a date override</button>
                                        </template>
                                        <template #action-preview="{ value }">
                                            <div class="flex justify-between w-full" v-if="selectedOverride.length">
                                                <div class="flex flex-col gap-2 __hours">
                                                    <div class="flex gap-2 items-center" v-for="(hour, hi) in date_override">
                                                        <div class="flex flex-col relative">
                                                            <input type="text" v-model="hour.start" class="form-input h__input w-[85px]" @click="showTimePicker($event,'', hi,'start')" />
                                                        </div>
                                                        -
                                                        <div class="flex flex-col relative">
                                                            <input type="text" v-model="hour.end" class="form-input h__input w-[85px]" @click="showTimePicker($event,'',hi,'end')" />
                                                        </div>
                                                        <div class="flex sh_icon delete" @click="deleteHours('', hi)"><icon name="trash" class="w-3 h-3" /></div>
                                                    </div>
                                                    <div v-if="!date_override.length" class="flex gap-3 justify-center items-center select-none h-[35px] opacity-75">
                                                        Unavailable
                                                    </div>
                                                </div>
                                                <div class="flex ml-2 gap-2 __clone__parent relative">
                                                    <div class="flex sh_icon __add" @click="newInterval('')"><icon name="plus" class="w-4 h-4" /></div>
                                                </div>
                                            </div>
                                        </template>
                                        <template #action-select>
                                            <div class="flex cancel__apply w-full gap-4 p-6" v-if="selectedOverride.length">
                                                <div class="flex __btn" @click="closeOverrideCalendar">Cancel</div>
                                                <div class="flex __btn" @click="applyOverride">Apply</div>
                                            </div>
                                        </template>
                                    </Datepicker>
                                    <div class="flex flex-col override__list">
                                        <div class="flex justify-between override__item" v-for="(override, oi) in form.hours.overrides" :key="oi">
                                            <div class="flex">{{ moment(override.day).format('D MMM YYYY') }}</div>
                                            <div class="flex gap-3 justify-between time__delete">
                                                <div class="flex w-full flex-col gap-4">
                                                    <div class="flex" v-for="(slot, si) in override.slots" :key="si">
                                                        {{ slot.start }} - {{ slot.end }}
                                                    </div>
                                                </div>
                                                <div class="flex">
                                                    <div class="__delete sh_icon" @click="deleteOverRide(oi)"><icon name="trash" class="w-4 h-4" /></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="pb-6 pr-6 w-full ">
                        <div class="flex w-full justify-between ">
                            <div class="flex flex-col w-3/5 gap-3">
                                <div class="form-label">Want to add time before or after your events?</div>
                                <div class="flex pb-8 flex-col gap-5 w-full max-w-[120px] duration__selection">
                                    <div class="flex flex-col gap-1">
                                        <label class="flex form-label" >
                                            <input class="flex justify-center items-center" type="checkbox" v-model="form.has_before" :value="true" :checked="form.has_before" />
                                            <div class="flex pl-3">Before Event</div>
                                        </label>
                                        <div class="flex w-full items-center form-select ml-6 cursor-pointer select-none" @click="show__bs = form.has_before?!show__bs:show__bs" :class="{'selected_ls':show__bs,'opacity-50':!form.has_before}">
                                            <div>{{ form.before.replace('_', ' ') }}</div>
                                        </div>
                                        <div v-if="show__bs" class="select__dd top-[60px] ml-6 flex flex-col">
                                            <div class="select__dd__item" v-for="(minute, mi) in before_after_selector" :key="mi" @click="form.before=minute;show__bs=false;">{{ minute.replace('_', ' ') }}</div>
                                        </div>
                                    </div>
                                    <div class="flex flex-col">
                                        <label class="flex form-label" >
                                            <input class="flex justify-center items-center" v-model="form.has_after" :value="true" :checked="form.has_after" type="checkbox" />
                                            <div class="flex pl-3">After Event</div>
                                        </label>
                                        <div class="flex w-full items-center form-select cursor-pointer ml-6 select-none" @click="show__as = form.has_after?!show__as:show__as" :class="{'selected_ls':show__as,'opacity-50':!form.has_after}">
                                            <div>{{ form.after.replace('_', ' ') }}</div>
                                        </div>
                                        <div v-if="show__as" class="select__dd top-[60px] ml-6 flex flex-col">
                                            <div class="select__dd__item" v-for="(minute, mi) in before_after_selector" :key="mi" @click="form.after=minute;show__as=false;">{{ minute.replace('_', ' ') }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-col w-2/5 py-4">
                                <p>Give yourself some buffer time to prepare for or wrap up from booked Calendly events.</p>
                            </div>
                        </div>
                    </div>

                    <select-input v-model="form.status" :error="form.errors.status" class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Status')">
                        <option value="1">Active</option>
                        <option value="0">InActive</option>
                    </select-input>
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create Event Type') }}</loading-button>
                </div>
            </form>
        </div>
        <div class="location_popup_overlay" v-if="show_location_selector_popup"></div>
        <div class="location_popup" v-if="show_location_selector_popup">
            <h3 class="text-2xl font-bold mb-5">Edit Location</h3>
            <div class="location_selector">
                <div class="flex items-center form-select w-full cursor-pointer select-none" :class="{'selected_ls':slc_popup}">
                    <div class="flex justify-start items-center location_item gap-3 w-full" v-if="popup_location_selected" @click="slc_popup = !slc_popup">
                        <img :src="popup_location_selected.image" class="w-6 h-6" />
                        <div class="flex flex-col w-full">
                            <div class="flex title text-sm">{{ popup_location_selected.name }}</div>
                        </div>
                    </div>
                </div>
                <div v-if="slc_popup" class="flex flex-col location_selection overflow-auto">
                    <div class="flex justify-start items-center location_item gap-3" v-for="event_location in popup_locations" :key="event_location.id" @click="locationClickAction(event_location)">
                        <img :src="event_location.image" class="w-6 h-6 ml-4" />
                        <div class="flex flex-col">
                            <div class="flex title text-sm">{{ event_location.name }}</div>
                            <div class="flex text-xs">{{ event_location.short_description }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="location-details mt-5">
                <text-input v-if="!popup_location_selected.name.includes('Phone')" v-model="popup_location_selected.value" class=" pb-6 w-full" :placeholder="popup_location_selected.details" label=""></text-input>
                <div v-else class="flex flex-col phone_call_selection gap-3 pb-6">
                    <div class="flex items-start justify-start gap-3">
                        <input class="who__call" type="radio" name="phone_type" v-model="phone_call_person" value="me" @change="setCallPerson()" />
                        <div class="flex flex-col gap-1 cursor-pointer" @click="phone_call_person='me'">
                            <div class="flex text-md">I will call my invitee</div>
                            <div class="flex text-sm">We will require your invitee’s phone number before scheduling.</div>
                        </div>
                    </div>
                    <div class="flex items-start justify-start gap-3">
                        <input class="who__call" type="radio" name="phone_type" v-model="phone_call_person" value="my_invitee" @change="setCallPerson()" />
                        <div class="flex flex-col gap-1 cursor-pointer" @click="phone_call_person='my_invitee'">
                            <div class="flex text-md">My invitee should call me</div>
                            <div class="flex text-sm">We will provide your number after scheduling.</div>
                            <text-input class="pb-6 w-full" placeholder="eg. 01239487847" v-model="popup_location_selected.value" v-if="phone_call_person === 'my_invitee'" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex gap-3 location_submission">
                <div class="btn w-1/2 bg-white hover:bg-[#f2f2f2] cursor-pointer" @click="cancelSelectedLocation">Cancel</div>
                <div class="bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white btn w-1/2 cursor-pointer" @click="locationUpdateAction(popup_location_selected)">Update</div>
            </div>
        </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import UploadAdapter from '@/Shared/UploadAdapter'
import Icon from '@/Shared/Icon'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'
import 'moment/locale/es';
moment.locale('es');

import moment_timezone from 'moment-timezone'
import { ref } from 'vue';

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
        Icon,
        Datepicker,
    },
    layout: Layout,
    props: {
        title: String,
        event_locations: Array,
    },
    remember: 'form',
    setup() {
        const dateOverride = ref(null);
        const closeOverrideCalendar = () => {
            if (dateOverride) {
                dateOverride.value.closeMenu()
            }
        }
        return {
            dateOverride,
            closeOverrideCalendar
        }
    },
    data() {
        return {
            selectedOverride: [],
            show__as: false,
            show__bs: false,
            show_z_sel: false,
            show_duration_selector: false,
            show_location_selector: false,
            show_location_selector_popup: false,
            slc_popup: false,
            selectedLocations: [],
            popup_location_selected: null,
            phone_call_person: 'me',
            popup_locations:[],
            popup_location_details:'',
            e_locations: this.event_locations,
            editor: ClassicEditor,
            duration_type: '',
            timezones: [],
            date_override: [{'start': '9:00am','end': '5:00pm'}],
            event_colors: [
                {color: "#ff4f00", name: "Red"}, {color: "#ff758e", name: "Light pink"}, {color: "#e55cff", name: "Magenta"},
                {color: "#8247f5", name: "Violet"}, {color: "#0099ff", name: "Blue"}, {color: "#0ae8f0", name: "Cyan"},
                {color: "#17e885", name: "Lime green"}, {color: "#ccf000", name: "Electric lime"}, {color: "#f8e436", name: "Bright yellow"},
                {color: "#ffa600", name: "Orange"}
            ],
            total_minutes: ['15_min','30_min','45_min','60_min','custom'],
            before_after_selector: ['5_min','10_min','15_min','30_min','45_min','1_hr','1_hr_30_min','2_hrs','2_hrs_30_min','3_hrs'],
            editorConfig: {
                toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'insertTable', 'blockQuote', '|', 'imageUpload', 'mediaEmbed', '|', 'undo', 'redo' ],
                table: {
                    toolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
                },
                extraPlugins: [this.uploader],
            },
            duration_in: 'min',
            duration_time: '30',
            typed_zone: '',
            show_duration_custom_selector: false,
            filteredTimezone: [],
            time_slot:[],
            days:['sun','mon','tue','wed','thu','fri','sat'],
            day_obj: {sat: false,sun: false,mon: false,tue: false,wed: false,thu: false,fri: false},
            form: this.$inertia.form({
                name: '',
                locations: [],
                location_details: [],
                details: '',
                link: '',
                timezone: '',
                color: '#8247f5',
                date_range: {type: 'days', days: '30'},
                duration: '30_min',
                has_before: false,
                has_after: false,
                before: '10_min',
                after: '10_min',
                schedule_id: null,
                hours: {
                    sun:[{'start': '9:00am','end': '5:00pm'}], mon:[{'start': '9:00am','end': '5:00pm'}],
                    tue:[{'start': '9:00am','end': '5:00pm'}], wed:[{'start': '9:00am','end': '5:00pm'}],
                    thu:[{'start': '9:00am','end': '5:00pm'}], fri:[{'start': '9:00am','end': '5:00pm'}],
                    sat:[{'start': '9:00am','end': '5:00pm'}], overrides:[] },
                max_per_day: null,
                status: 1,
            }),
        }
    },
    methods: {
        setEventLink(){
            this.checkEventLink(this.form.name)
        },
        checkEventLink(name){
            this.axios.post(this.route('event_types.link.create'), {name: name}).then((response) => {
                if(response.data){
                    if(!response.data.link){
                        this.form.link = name.replace(/[^a-zA-Z0-9]/g,'-').toLowerCase()
                    }else{
                        const link = name.replace(/[^a-zA-Z0-9]/g,'-').toLowerCase()
                        const char = link.substr(link.length - 1)
                        this.form.link = link + (!isNaN(parseInt(char))?char+1:1)
                    }
                }
            }).catch((error) => {
                console.log(error)
            })
        },
        deleteOverRide(index){
            this.form.hours.overrides.splice(index, 1)
        },
        applyOverride(){
            this.selectedOverride.forEach(d=>{
                const findIndex = this.form.hours.overrides.findIndex(el => el['day'] === d)
                if(findIndex === -1){
                    this.form.hours.overrides.push({
                        'day': d,
                        'slots': this.date_override
                    })
                }else{
                    this.form.hours.overrides[findIndex] = { 'day': d, 'slots': this.date_override }
                }
            })
            this.selectedOverride = []
            this.date_override = []
            this.closeOverrideCalendar()
        },
        handleOverrideDate(modelData){
            if(modelData.length && !this.date_override.length){
                this.date_override.push({'start': '9:00am','end': '5:00pm'})
            }
        },
        cloneSlot(event, day){
            const weekDays = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
            const target = event.target
            const parentTarget = target.closest('.__clone__parent')
            let divParent = document.createElement('div');
            divParent.classList.add('copy__slot')

            const divTitle = document.createElement('div')
            divTitle.classList.add('__title')
            divTitle.innerText = 'Copy slot to'
            divParent.appendChild(divTitle)

            let k = 0
            let checkedValues = []
            while (k < weekDays.length) {
                let divMain = document.createElement('label');
                divMain.classList.add('__day');
                divMain.innerText = weekDays[k]

                let input = document.createElement('input');
                input.type = 'checkbox'
                input.name = 'days'
                input.value = weekDays[k]

                if(weekDays[k].substr(0,3) === day){
                    input.checked = true
                    input.disabled = true
                }

                divMain.appendChild(input)

                input.onchange = (e) => {
                    if(e.currentTarget.checked){
                        checkedValues.push(e.target.value)
                    }else{
                        const findIndex = checkedValues.findIndex(el => el === e.target.value)
                        if(findIndex){
                            checkedValues.splice(findIndex, 1)
                        }
                    }
                }

                divParent.appendChild(divMain)
                k+=1
            }

            const divApply = document.createElement('div')
            divApply.classList.add('__apply')
            divApply.innerText = 'Apply'
            divApply.onclick = () => {
                let checkedDays = checkedValues.map( v => v.substr(0,3))
                checkedDays.forEach( cd => {
                    this.form.hours[cd] = this.form.hours[day].map(object => ({ ...object }))
                })
                parentTarget.removeChild(divParent);
            }
            divParent.appendChild(divApply)
            parentTarget.appendChild(divParent);
        },
        toggleHours(day){
            if(this.form.hours[day].length){
                this.form.hours[day] = []
            }else{
                this.form.hours[day].push({'start': '9:00am','end': '5:00pm'})
            }
        },
        newInterval(day){
            if(day){
                if(this.form.hours[day].length){
                    const lastDate = this.moment(this.form.hours[day][this.form.hours[day].length - 1]['end'], 'h:mma')
                    this.form.hours[day].push({'start': lastDate.add(1, 'hour').format('h:mma'), 'end': lastDate.add(1, 'hour').format('h:mma')})
                }else{
                    this.form.hours[day].push({'start': '9:00am','end': '5:00pm'})
                }
            }else{
                if(this.date_override.length){
                    const lastDate = this.moment(this.date_override[this.date_override.length - 1]['end'], 'h:mma')
                    this.date_override.push({'start': lastDate.add(1, 'hour').format('h:mma'), 'end': lastDate.add(1, 'hour').format('h:mma')})
                }else{
                    this.date_override.push({'start': '9:00am','end': '5:00pm'})
                }
            }
        },
        deleteHours(day, index){
            if(day){
                this.form.hours[day].splice(index, 1)
            }else{
                this.date_override.splice(index, 1)
            }
        },
        showTimePicker(event, day, index, position){
            const target = event.target
            let divParent = document.createElement('div');
            divParent.classList.add('flex','flex-col','select__dd','top-[34px]', 'w-[100px]', 'hp__parent')
            let k = 0
            const currentIndex = this.time_slot.findIndex(el => el === target.value)
            while (k < this.time_slot.length) {
                let divMain = document.createElement('div');
                divMain.classList.add('flex', 'select__dd__item', 'hour_pic');
                divMain.innerText = this.time_slot[k]
                divMain.onclick = () => {
                    if(day){
                        this.form.hours[day][index][position] = divMain.innerText
                    }else{
                        this.date_override[index][position] = divMain.innerText
                    }
                    target.parentElement.removeChild(divParent)
                }
                divParent.appendChild(divMain)
                k+=1
            }
            target.parentElement.appendChild(divParent);
            divParent.scroll(0, 36 * (currentIndex + 1))
        },
        setTimezone(zone){
            this.form.timezone = zone
            this.show_z_sel = false
        },
        limitTimezone(value){
            const pat =  new RegExp(value.toLowerCase())
            this.filteredTimezone = this.timezones.filter( t => pat.test(t.toLowerCase()))
        },
        selectedDuration(duration){
            if(duration !== 'custom'){
                this.form.duration = duration
                this.duration_type = ''
            }else{
                this.duration_type = duration
            }
            this.show_duration_selector = false
        },
        selectedDurationIn(type){
            this.duration_in = type
            this.form.duration = this.duration_time+'_'+this.duration_in;
            this.show_duration_custom_selector = false;
        },
        removeLocation(location){
            this.form.locations = this.form.locations.filter(item => item.id !== location.id)
            const findIndex = this.e_locations.findIndex(item => item.id === location.id)
            if(findIndex === -1){
                this.e_locations.push(location)
            }
        },
        cancelSelectedLocation(){
            this.show_location_selector_popup = false
            this.popup_location_selected = null
        },
        setCallPerson(phone){

        },
        uploader(editor) {
            editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
                return new UploadAdapter( loader );
            };
        },
        locationClickAction(location){
            this.show_location_selector_popup = true
            this.popup_location_selected = location
            this.show_location_selector = false
            this.slc_popup = false
            this.popup_locations = this.e_locations.filter(el => el.id !== location.id)
        },
        locationUpdateAction(location){
            const findIndex = this.form.locations.findIndex(item => item.id === location.id)
            if(findIndex === -1){
                location.value = this.popup_location_selected.value || ''
                this.form.locations.push(location)
            }
            this.show_location_selector_popup = false
            this.popup_location_selected = null;
            this.e_locations = this.e_locations.filter(el => el.id !== location.id)
        },
        locationPopupClickAction(location){
            this.selectedLocations.push(location)
            this.form.locations.push(location)
        },
        existDays(obj){
            let haveSlot = false
            for (let i = 0; i < this.days.length; i++) {
                if (obj[this.days[i]] && obj[this.days[i]].length) {
                    haveSlot = true
                    break;
                }
            }
            return haveSlot
        },
        store() {
            if(!this.form.locations.length){
                alert('Please select a location for the event!')
                return
            }else if(!this.form.details){
                alert('Please input some instructions or details information!')
                return
            }else if(!this.existDays(this.form.hours)){
                alert('Please set weekly hours correctly!')
                return
            }
            this.form.post(this.route('event_types.store'))
        },
        generateTime(){
            let startTime = this.moment().startOf('day')
            const endTime = this.moment().endOf('day')
            while (startTime < endTime) {
                this.time_slot.push(new this.moment(startTime).format('h:mma'))
                startTime.add(15, 'minutes')
            }
        }
    },
    mounted() {
        this.generateTime()
        document.onclick = (ev) => {
            if(!ev.target.classList.contains('h__input')){
                document.querySelectorAll('.hp__parent').forEach(e => e.remove());
            }
            if(!ev.target.closest('.__clone__parent')){
                document.querySelectorAll('.copy__slot').forEach(e => e.remove());
            }
        }
    },
    created() {
        this.moment = moment_timezone
        this.timezones = this.moment.tz.names()
        this.filteredTimezone = this.timezones
        this.form.timezone = this.moment.tz.guess()
    },
}
</script>
